import React, { FC, useMemo, memo, useContext, useCallback } from "react";
import SelectFilter from "../components/SelectFilter";
import { FiltersContext } from "../context/FiltersProvider";
import { SelectFilterOption, FilterType } from "../types";

const StatusFilter: FC = () => {
  const { actions } = useContext(FiltersContext);
  const statusOptions: SelectFilterOption[] = useMemo(
    () => [
      { value: "ALL", label: "All" },
      { value: "open", label: "Open" },
      { value: "closed", label: "Closed" },
    ],
    []
  );
  const handleSelected = useCallback(
    (status: string) => actions.onSelect(FilterType.STATUS, status),
    [actions.onSelect]
  );
  return (
    <SelectFilter
      label="Status"
      options={statusOptions}
      onSelect={handleSelected}
    />
  );
};

export default memo(StatusFilter);



// WEBPACK FOOTER //
// ./src/share/components/Filters/inputs/StatusFilter.tsx